import { render, staticRenderFns } from "./RanchTableManager.vue?vue&type=template&id=7048156c&scoped=true&"
import script from "./RanchTableManager.vue?vue&type=script&lang=js&"
export * from "./RanchTableManager.vue?vue&type=script&lang=js&"
import style0 from "./RanchTableManager.vue?vue&type=style&index=0&id=7048156c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7048156c",
  null
  
)

export default component.exports